import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export default function Footer() {
  const theme = useTheme();
  const handleCopyrightClick = () => {
    window.open('/copyright.html', '_blank', 'noopener,noreferrer');
  };
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        borderTop: theme => `1px solid ${theme.palette.divider}`,
        py: 2,
        px: { xs: 2, sm: 3 },
        mt: 'auto',
        position: 'sticky',
        bottom: 0,
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{ cursor: 'pointer', '&:hover': { color: 'primary.main' } }}
        onClick={handleCopyrightClick}
      >
        © {new Date().getFullYear()} Omnevu.com. All rights reserved.
      </Typography>
    </Box>
  );
}